import { Stack, YStack } from '@my/ui'
import { RichText } from 'app/components'
import React from 'react'
import { RedeemOutput } from '../../services/redeem'
import { OfferLink } from '../offer-link'

interface RedeemedDialogPageProps {
  redemption: RedeemOutput
}

export function RedeemedDialogPage({ redemption }: RedeemedDialogPageProps) {
  return (
    <Stack px="$4" width="100%">
      <YStack alignItems="center" justifyContent="center" mb="$2">
        {redemption.redemptionInstructions && (
          <RichText content={redemption.redemptionInstructions} />
        )}
      </YStack>
      <OfferLink
        link={redemption.offerLink}
        code={redemption.redeemCode}
        validUntil={redemption.validUntil}
      />
    </Stack>
  )
}
